import { useTranslation } from "react-i18next"
import { useFragment } from "react-relay"
import { CardBody } from "@/components/ui/card"
import { EditorView } from "@/components/ui/editor"
import { AttachmentsSection } from "@/modules/patients/detail/progress-note/attachments"
import { ProgressNoteReadOnlyCardSection } from "@/modules/patients/detail/progress-note/components/progress-note-readonly-card-section"
import { QuestionnaireReadOnly } from "@/modules/patients/detail/progress-note/components/questionnaire-readonly"
import { ProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"
import { QuestionnaireCriticalitySummaryFragment$key } from "@/modules/patients/services/__generated__/QuestionnaireCriticalitySummaryFragment.graphql"
import { QuestionnaireCriticalitySummaryFragment } from "@/modules/patients/services/QuestionnaireCriticalitySummaryFragment"

export const AdministrativeProgressNoteReadOnlyCardBody = ({ progressNote }: { progressNote: ProgressNoteData }) => {
  const { t } = useTranslation()
  const {
    appointment: {
      reason,
      appointmentAttachments,
      id,
      telephoneLine,
      questionnaireId,
      questionnaireCriticalitySummary,
      createdAt: appointmentCreatedAt,
    },
    anamnesis,
  } = progressNote

  const criticalitySummary = useFragment<QuestionnaireCriticalitySummaryFragment$key>(
    QuestionnaireCriticalitySummaryFragment,
    questionnaireCriticalitySummary,
  )

  return (
    <CardBody>
      <ProgressNoteReadOnlyCardSection
        title={t("episodeOfCare.progressNote.reasonForEncounter")}
        testId="admin-reason-for-encounter-read-only">
        <div className="grid gap-4">
          <span>{reason}</span>
          {questionnaireId && criticalitySummary && (
            <QuestionnaireReadOnly
              completedAt={appointmentCreatedAt}
              name={criticalitySummary.useCaseName}
              questionnaireId={questionnaireId}
              questionnaireCriticalitySummary={questionnaireCriticalitySummary}
              appointmentId={progressNote.appointment.id}
              asyncRequestStatus={progressNote.appointment.asyncRequestStatus}
              channel={progressNote.appointment.channel}
            />
          )}
          <AttachmentsSection
            appointmentAttachments={appointmentAttachments}
            telephoneLine={telephoneLine}
            appointmentId={id}
            isReadOnlyProgressNote
          />
        </div>
      </ProgressNoteReadOnlyCardSection>
      {anamnesis && anamnesis.trim().length > 0 && (
        <ProgressNoteReadOnlyCardSection
          className="border-t"
          title={t("common.comment")}
          testId="admin-comment-read-only">
          <EditorView name="comment" initialValue={anamnesis} />
        </ProgressNoteReadOnlyCardSection>
      )}
    </CardBody>
  )
}
